var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"span",on:{"click":_vm.clickHandler}},[(!_vm.items.length)?_c('li',[_c('span',{staticClass:"inline-block px-2"})]):_vm._e(),_vm._l((_vm.items),function(item,index){return _c('li',{key:index},[_vm._v(_vm._s(item))])})],2)}
var staticRenderFns = []

export { render, staticRenderFns }